import { Dialog, Grid, IconButton, Paper, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ClearIcon from '@mui/icons-material/Clear';

const SuccessAlert = ({ open, title, description, onAlertClose }) => {
    return (
        <Dialog open={open}>
            <Paper sx={{ padding: '14px 19px', width: '380px', borderLeft: '2px solid #98CD6C' }}>
                <Grid container spacing={0}>
                    <Grid item xs={1} sx={{ textAlign: 'center' }}>
                        <CheckCircleIcon sx={{ color: '#98CD6C' }} />
                    </Grid>
                    <Grid item xs={10}>
                        <Typography className="alert-title" component="div">
                            {title}
                        </Typography>
                        <Typography className="alert-description" component="div">
                            {description}
                        </Typography>
                    </Grid>
                    <Grid item xs={1}>
                        <IconButton sx={{ padding: 0 }} onClick={onAlertClose}>
                            <ClearIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </Paper>
        </Dialog>
    );
};

export default SuccessAlert;
